import { removeDuplicates } from 'utils/arrays';
import { IsJsonString } from 'utils/mails';
import _ from 'lodash';
import {
  SmsFemaleConnectedOptions,
  SmsFemaleEPDMConnectionOptions,
  SmsFemaleConnectionOptions,
  SmsMaleConnectionOptions,
  DinFemaleConnectedOptions,
  DinFemaleConnectionOptions,
  DinFemaleEPDMConnectionOptions,
  DinMaleConnectionOptions,
  ClampConnectionOptions,
  CamlockConnectionOptions,
  GuilleminConnectionOptions,
  typeOptions,
} from 'containers/specifications/constants';

function filterDryMatter(codes) {
  if (codes.length > 1 && codes.includes('E')) {
    const index = codes.findIndex(el => el === 'E');
    if (index !== -1) {
      codes[index] = 'eWarning';
    }
  }
  return codes;
}

function getCodePerRecipe(ingredients) {
  const codes = [];
  const ingredientsArray = typeof ingredients === 'string' ? JSON.parse(ingredients) : ingredients;
  ingredientsArray.forEach(ingredient => {
    ingredient.code.forEach(code => {
      if (code.letters.code === 'B' && code.letters.condition === 'X(*)') {
        if (ingredient.condition && ingredient.condition < 4.5) {
          codes.push(code.letters.code);
        }
      } else {
        codes.push(code.letters.code);
      }
    });
  });
  const filteredCodes = removeDuplicates(codes);
  const checkedDryMatter = filterDryMatter(filteredCodes);
  return checkedDryMatter.sort();
}

function getCodesWithMessage(ingredients) {
  const codes = getCodePerRecipe(ingredients);
  let hasWarning = false;
  if (codes.includes('eWarning')) {
    hasWarning = true;
    const index = codes.indexOf('eWarning');
    codes.splice(index, 1);
  }
  const message = hasWarning ? 'Le simulant E n’est pas pris en compte '
    + 'car l\'ensemble n\'est pas une denrée alimentaire sèche' : '';
  return { message, codes };
}

function getCodeLetterForPdf(ingredients) {
  const { message, codes } = getCodesWithMessage(ingredients);
  if (!codes) return false;
  return { message, codes: codes.join(', ') };
}

function getCodeForFlexibleFeatures(recipe) {
  const ingredients = IsJsonString(recipe?.ingredients) ? JSON.parse(recipe?.ingredients) : recipe?.ingredients || {};
  const codes = getCodePerRecipe(ingredients);
  return codes;
}

function getSmsConnectionDnByCode() {
  const connection = _.flatten([SmsFemaleConnectedOptions,
    SmsFemaleEPDMConnectionOptions,
    SmsFemaleConnectionOptions,
    SmsMaleConnectionOptions]).find(con => con.value === this);
  // eslint-disable-next-line no-debugger
  return connection?.label;
}

function getDinConnectionDnByCode(code) {
  const connection = _.flatten([DinFemaleConnectedOptions,
    DinFemaleConnectionOptions,
    DinFemaleEPDMConnectionOptions,
    DinMaleConnectionOptions]).find(con => con.value === code);
  return connection?.label;
}

function getClampConnectionDnByCode(code) {
  const connection = ClampConnectionOptions.find(con => con.value === code);
  return connection?.label;
}

function getCamlockConnectionDnByCode(code) {
  const connection = CamlockConnectionOptions.find(con => con.value === code);
  return connection?.label;
}

function getGuilleminConnectionDnByCode(code) {
  const connection = GuilleminConnectionOptions.find(con => con.value === code);
  return connection?.label;
}

function getMaconConnectionDnByCode(code) {
  const connection = typeOptions.find(con => con.doptions[0].value === code);
  return connection?.label;
}

const connectionApplies = {
  sms: getSmsConnectionDnByCode,
  din: getDinConnectionDnByCode,
  clamp: getClampConnectionDnByCode,
  camlock: getCamlockConnectionDnByCode,
  guillemin: getGuilleminConnectionDnByCode,
  macon: getMaconConnectionDnByCode
};

function getConnectionDiameterByCode(type, code) {
  const lol = connectionApplies[type.toLowerCase()].apply(code);
  // eslint-disable-next-line no-debugger
  return lol;
}

export {
  getCodePerRecipe,
  getCodeLetterForPdf,
  getCodesWithMessage,
  getCodeForFlexibleFeatures,
  getConnectionDiameterByCode,
};
